export class ExtractedPaymentsDto {
  paymentMethodName: string;
  paymentValue: number;
}